import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appHasPermissions]',
})
export class HasPermissionsDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input()
  set appHasPermissions(permission: string | string[] | undefined | null) {
    const requiredPermissions = this.normalizePermissions(permission);
    const storedPermissions = this.getStoredPermissions();
    const shouldShow = requiredPermissions.some(permission =>
      storedPermissions.includes(permission)
    );

    this.updateView(shouldShow);
  }

  private normalizePermissions(
    permission: string | string[] | undefined | null
  ): string[] {
    if (!permission) {
      return [];
    }

    return Array.isArray(permission) ? permission : [permission];
  }

  private getStoredPermissions(): string[] {
    const stored = localStorage.getItem('permissions');
    if (!stored) {
      return [];
    }

    try {
      return JSON.parse(stored);
    } catch {
      return [];
    }
  }

  private updateView(shouldShow: boolean): void {
    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      return;
    }

    if (!shouldShow) {
      this.viewContainer.clear();
    }
  }
}
